<template>
  <div class="yo-app">
    <!-- <yo-button :cta="cta" :styler="styler" @click="initYoTeach()"></yo-button> -->
    <transition name="fade">
      <yo-room v-if="show === 'room'" :marker="marker" :earthID="earthID" :ownerID="ownerID" :userData="userData" @switch="onSwtich" :room="room"></yo-room>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    earthID: {},
    ownerID: {},

    room: {},
    cta: {},
    styler: {},
    marker: {},
    userData: {}
  },
  components: {
    'yo-button': require('../yo/button.vue').default,
    // 'yo-welcome': require('../widget/welcome.vue').default,
    'yo-room': require('../widget/room.vue').default
  },
  data () {
    return {
      show: 'none'
    }
  },
  mounted () {
    // this.$el.click()
    this.initYoTeach()
    // this.show = 'room'
  },
  methods: {
    onSwtich (v) {
      if (v === 'on') {
        this.show = 'room'
      } else {
        this.show = 'none'
      }
    },
    initYoTeach () {
      // window.addEventListener('keydown', (evt) => {
      //   if (evt.keyCode === 27) {
      //     this.show = 'none'
      //   }
      // })

      if (this.show === 'room') {
        this.show = 'none'
      } else {
        this.show = 'room'
      }

      // this.$forceUpdate()
      // setTimeout(() => {
      //   if (this.room) {
      //     this.show = 'room'
      //   }
      // }, 2000)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC|Quicksand');

.full{
  width: 100%;
  height: 100%;
}

.yo-app{
  font-family: 'Quicksand', 'Noto Sans TC',  'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* height: 100%; */

  /* position: absolute;
  bottom: 0px;
  right: 0px; */
  /* width: 100%; */
  /* height: 0px; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style>
</style>
